import { useMutation } from '@tanstack/react-query';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

type EditAIPromptTemplateDto = {
  _id: string;
  aiId: number;
  template: string;
};

export const editAIPromptTemplate = ({ _id, ...data }: EditAIPromptTemplateDto) => {
  return axios.patch(`/ai/prompt-templates/${_id}`, data);
};

type QueryFnType = typeof editAIPromptTemplate;

type UseEditAIPromptTemplateOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useEditAIPromptTemplate = ({ config }: UseEditAIPromptTemplateOptions = {}) => {
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    ...restConfig,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['ai-prompt-templates']);
      onSuccess?.(...args);
    },
    mutationFn: editAIPromptTemplate,
  });
};
